import React from "react";
import Breadcrumb from "../widgets/Breadcrumb";

const BannerWithoutImage = ({ label, src }) => {
  return (
    <div className="bg-[#f4f0ed] flex flex-col justify-center items-center text-darkLiver xl:text-5xl lg:text-5xl md:text-5xl sm:text-4xl font-normal font-cormorantGaramond uppercase tracking-[.2em] py-28  overflow-hidden w-full text-center">
      {label}
      <Breadcrumb />
    </div>
  );
};

export default React.memo(BannerWithoutImage);
